import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Table,
  Input,
  Select,
  Form,
  Tooltip,
  Col,
  Spin,
  Radio,
  Row,
} from "antd";
import { Collapse } from "antd";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
const { Panel } = Collapse;

export const SPECIFIC_GRAVITY = {
  GI: 7.85,
  MS: 7.85,
  CU: 8.96,
  AL: 2.7,
  SS: 8.0,
};

export function getDensity(material) {
  const sg = SPECIFIC_GRAVITY[material.toUpperCase()] || 0;
  return sg * 1000;
}

export function getKgPerMeter(widthMM, thicknessMM, material) {
  const density = getDensity(material);
  const widthM = widthMM / 1000;
  const thicknessM = thicknessMM / 1000;
  const lengthM = 1; 
  const volume = widthM * thicknessM * lengthM;
  return density * volume;
}


const NewCitywiseAssignPurchaseDetails = ({ PRid }) => {
  const [siteName, setSiteName] = useState([]);
  const navigate = useNavigate();
  const { Option } = Select;
  const [pincodeList, setPincodeList] = useState([]);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);
  const [view, setView] = useState("");
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const { id, prId } = useParams();
  const formRef = useRef();

  const [estimatedValueFromApi, setEstimatedValueFromApi] = useState([
    {
      id: "",
      value: "",
    },
  ]);
  const [tableData, setTableData] = useState([]);

  const [stateWBS, setStateWBS] = useState([]);

  const initialState = {
    company: CompanyID,
    category_tree: id,
    total_amount: null,
    purchase_requisition_details: [],
  };
  const [state, setState] = useState([]);

  const [siteWiseTotalAmount, setSiteWiseTotalAmount] = useState({
    siteName: "",
    total: "",
  });

  const [siteTotalQuantities, setSiteTotalQuantities] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [cityLength, setCityLength] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [apiLoading, setapiLoading] = useState(false);
  const [viewOption, setViewOption] = useState(false);
  const [prView, setPRView] = useState(null);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [overallTotal, setOverallTotal] = useState(0);

  const getSubCategory = async () => {
    setapiLoading(true);

    try {
      let apiResponse = await getRequest(`purchase-requisition/${PRid}/`);
      if (apiResponse.data.success) {
        setState(apiResponse.data.data);
        setPRView(apiResponse?.data?.data?.pr_type);
        setSelectedCategoryName(apiResponse?.data?.data?.category_tree_name);
        const prType = apiResponse.data.data.pr_type || "Material Wise";
        setView(prType);

        formRef.current.setFieldsValue({
          pr_view: prType,
        });
      }

      if (apiResponse.data.data) {
        const purchaseRequisitionDetails = apiResponse.data.data.map((item) => {
          // const siteWise = siteName.map((site) => ({
          //   site_name: site.id,
          //   quantity: null, // Set the initial quantity to null or whatever default value you need
          // }));
          // return {
          //   material_type: item.id,
          //   unit_of_measurement: 1,
          //   total_quantity: 0,
          //   site_wise: siteWise,
          // };
        });
        setState((prevState) => ({
          ...prevState,
          purchase_requisition_details: purchaseRequisitionDetails,
        }));
        const uniqueSubCategories = Array.from(
          new Set(apiResponse.data.data.map((item) => item.sub_category)),
        );
        setSubCategoryList(uniqueSubCategories);
        setSubCategoryData(apiResponse.data.data);
        setapiLoading(false);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
      setapiLoading(false);
      // setTimeout(() => setapiLoading(false), 1000);
    } catch (error) {
      setapiLoading(false);
      // setTimeout(() => setapiLoading(false), 1000);
    }
  };

  useEffect(() => {
    getSubCategory();
    getCurrency();
    getUnitOfMeasurement();
    if (siteName.length === 0) {
      getSiteName();
    }
  }, [id, prId]);

  let updateTableData = [];

  updateTableData = (state) => {
    // setapiLoading(true);
    const tableData = [];
    const length = state?.city_site_material_data?.length;
    // const length = 2;

    setCityLength(length);

    state?.city_site_material_data?.forEach((city, cityIndex) => {
      const cityRowSpan = city.site_wise_pr.length;
      let cityTotalQuantity = 0;
      let cityTotalQuantityByKg = 0;
      let cityTotal = 0;
      // cityTotal += cityTotalQuantity;
      let cityAmount = 0;

      city.site_wise_pr.forEach((site, siteIndex) => {
        let siteTotalQuantity = 0;
        let siteTotalQuantityForKG = 0;
        let siteMaterialTotal = 0;
        site.site_total_quantity += siteTotalQuantity;

        let siteAmount = 0;
        site.pr_material_details?.forEach((material) => {
          siteTotalQuantity += material.pr_material_type_quantity;
          siteMaterialTotal += material.pr_material_type_quantity * 105;
          siteTotalQuantityForKG += material.pr_material_type_quantity_by_kg;
          siteAmount +=
            material.pr_material_type_quantity_by_kg === 0
              ? material.pr_material_type_quantity *
                material.estimated_material_unit_price
              : material.pr_material_type_quantity_by_kg *
                material.estimated_material_unit_price;
        });
        site.site_total_quantity = siteTotalQuantity;
        setSiteTotalQuantities((prevQuantities) => [
          ...prevQuantities,
          siteTotalQuantity,
        ]);

        cityTotalQuantity += siteTotalQuantity;
        cityTotal += siteMaterialTotal;
        cityTotalQuantityByKg += siteTotalQuantityForKG;
        cityAmount += siteAmount;

        tableData.push({
          key: `${cityIndex}-${siteIndex}`,
          // srNo: siteIndex === 0 ? cityIndex + 1 : null,
          srNo:
            length > 1
              ? siteIndex === 0
                ? cityIndex + 1
                : null
              : siteIndex + 1,
          cityName: siteIndex === 0 ? city.city_name : null,
          cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
          siteName: site.site_name,
          siteLocations: site.pr_material_details?.map((material, matIndex) => {
            console.log("material560 ", material);

            return {
              availableBudget: material.available_budget || 0,
              estimatedPRValue: 185 || 0,
              remark: material.remark,
              materialName: material.pr_material_type_name,
              quantity: material.pr_material_type_quantity,
              quantityForKG: material.pr_material_type_quantity_by_kg,
              // siteTotalQuantity: siteTotalQuantity,
              uom: material.pr_material_type_uom_id,
              uom_name: material.pr_material_type_uom_name,
              subCategory: material.pr_material_type_sub_category,
              siteIndex,
              matIndex,
              cityId: city.city_name,
              siteId: site.pr_site_id,
              estimatedPrice: material.estimated_material_unit_price,
              amount:
                material.pr_material_type_quantity_by_kg !== 0
                  ? material.pr_material_type_quantity_by_kg *
                    material.estimated_material_unit_price
                  : material.pr_material_type_quantity *
                    material.estimated_material_unit_price,
            };
          }),
          totalAmount: (
            <Input
              disabled
              // value={`\u20B9 ${5658 || 0}`}
              className="site-subtotal"
              // readOnly
            />
          ),
        });

        // Add site-sub-total row
        tableData.push({
          key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
          siteName: "Site Sub-Total",
          siteLocations: [
            {
              totalQuantity: siteMaterialTotal,
              materialName: "",
              quantity: siteTotalQuantity,
              quantityForKG: siteTotalQuantityForKG,
              subCategory: "",
              siteIndex,
              matIndex: 0,
              cityId: city.city_id,
              siteId: site.site_id,
              amount: siteAmount,
            },
          ],
          totalAmount: (
            <Input
              disabled
              value={`\u20B9 ${siteTotalQuantity || 0}`}
              className="site-subtotal"
              // readOnly
            />
          ),
          siteTotalQuantity: (
            <Input
              disabled
              value={siteTotalQuantity || 0}
              className="site-total-quantity"
              readOnly
            />
          ),
        });

        // Add city total row at the end of the city's site list
        if (length > 1) {
          if (siteIndex === city.site_wise_pr.length - 1) {
            tableData.push({
              key: `${cityIndex}-${siteIndex}-CityTotal`,
              siteName: "City Total",
              siteLocations: [
                {
                  materialName: "",
                  cityTotal: cityTotal,
                  quantity: cityTotalQuantity,
                  quantityForKG: cityTotalQuantityByKg,
                  subCategory: "",
                  siteIndex,
                  matIndex: 0,
                  cityId: city.city_id,
                  siteId: site.site_id,
                  amount: cityAmount,
                },
              ],
              totalAmount: (
                <Input
                  disabled
                  value={`\u20B9 ${cityTotalQuantity || 0}`}
                  className="subtotal"
                  readOnly
                />
              ),
              cityTotalQuantity: (
                <Input
                  disabled
                  value={city.city_total_quantity || 0}
                  className="city-total-quantity"
                  readOnly
                />
              ),
            });
          }
        }
      });

      city.city_total_quantity = cityTotal;
    });
    setTableData(tableData);
    // setapiLoading(false);
  };

  useEffect(() => {
    // setapiLoading(true);
    updateTableData(state);
    // setapiLoading(false);
  }, [state]);

  const getUnitOfMeasurement = async (data) => {
    // setapiLoading(true);
    await getRequest("get-category-by-uom/?category_tree", data).then(
      (response) => {
        setPincodeList(response.data.results.data);
      },
    );
    // setapiLoading(false);
  };

  const getSiteName = async () => {
    //setLoading(true);

    try {
      let apiResponse = await getRequest(
        `delivery-address/${CompanyID}/address-by-company/`,
      );
      if (apiResponse.data.data) {
        setSiteName(apiResponse.data.data);
        const updatedState = { ...state };
        updatedState.purchase_requisition_details.forEach((detail) => {
          detail.site_wise.forEach((site, index) => {
            site.site_name = apiResponse.data.data[index]
              ? apiResponse.data.data[index].site.id
              : null;
          });
        });

        setState(updatedState);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
      //setLoading(false);
    } catch (error) {
      //setLoading(false);
    }
  };

  const subCategoryColumnsWBC = [
    {
      title: "WBS",
      dataIndex: "WBS",
      key: "WBS",
      render: (text, record, rowIndex) => <span>{stateWBS[rowIndex]}</span>,
    },
  ];

  const WBCsiteNameColumns = siteName.map((item, index) => ({
    title: item.site_name,
    dataIndex: `site_name_${index}`,
    key: `site_name_${index}`,
    render: (text, record, rowIndex) => (
      <>
        <Input
          addonBefore={currencySymbol}
          style={{ width: "100%" }}
          value={rowIndex ? siteWiseTotalAmount[item.id] : ""}
          readOnly
        />
      </>
    ),
    width: 170,
  }));

  const handleInputChange = (e, cityId, siteId, matIndex) => {
    const { value } = e.target;
    if (prId) {
      setState((prevState) => {
        const newState = { ...prevState };
        console.log("newState 124 ", newState);
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          console.log("city 01 ", city);
          if (city.city_name === cityId) {
            city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
              console.log("site 01", site);
              if (site.pr_site_id === siteId) {
                console.log("site 10", site);
                site.pr_material_details[matIndex].pr_material_type_quantity =
                  parseFloat(value) || 0;
              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    } else {
      setState((prevState) => {
        const newState = { ...prevState };
        console.log("newState 124 ", newState);
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_id === cityId) {
            city.site_wise_details = city.site_wise_details.map(
              (site, siteIndex) => {
                if (site.site_id === siteId) {
                  console.log("site 10", site);
                  site.material_wise_details[matIndex].material_type_quantity =
                    parseFloat(value) || 0;
                }
                return site;
              },
            );
          }
          return city;
        });
        return newState;
      });
    }
  };

  const handleUOMChange = (value, cityId, siteId, matIndex) => {
    if (prId) {
      console.log("state 25 ", state);
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          console.log("bc", city);
          if (city.city_name === cityId) {
            console.log("ab");
            city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
              console.log("site 84 ", site);
              if (site.pr_site_id === siteId) {
                site.pr_material_details[matIndex].pr_material_type_uom = value;
              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    } else {
      console.log("state 26 ", state);

      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_id === cityId) {
            city.site_wise_details = city.site_wise_details.map(
              (site, siteIndex) => {
                if (site.site_id === siteId) {
                  site.material_wise_details[matIndex].material_type_uom =
                    value;
                }
                return site;
              },
            );
          }
          return city;
        });
        return newState;
      });
    }
  };
  const filterItemsBySubCategory = (subCategory) => {
    return subCategoryData.filter((item) => item.sub_category === subCategory);
  };

  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data,
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  const wbsBudget = [
    {
      title: "SR.",
      dataIndex: "srNo",
      fixed: "left",
      width: 100,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      fixed: "left",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    },
    {
      title: "Available Budget",
      dataIndex: "siteLocations",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName !== "City Total" && record.siteName !== "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              {/* {siteLocations.map((site, index) => ( */}
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  readOnly
                  value={1000000}
                />
              </div>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Estimated PR Value",
      dataIndex: "siteLocations",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName === "City Total" || record.siteName === "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  value={siteLocations[0].cityTotal}
                  readOnly
                />
              </div>
            </div>
          );
        } else {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  value={siteLocations[0].estimatedPRValue}
                  readOnly
                />
              </div>
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    wbsBudget.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    });
  }

  const theadWbsBudget = <Table columns={wbsBudget} />;

    const parseEarthingStrip = (name) => {
    const match = name.match(/(\d+)\s*x\s*(\d+)\s*[-–]\s*(\w+)/i);
    if (!match) return null;
    return {
      width: parseFloat(match[1]),
      thickness: parseFloat(match[2]),
      material: match[3].toUpperCase(), // CU or GI
    };
  };

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      fixed: "left",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <div className="subtotal">{"Sub total"}</div>;
        } else if (record.siteName === "City Total") {
          return <div className="citytotal">{"City total"}</div>;
        } else {
          return <>{record.siteName}</>;
        }
      },
    },
    {
      title: selectedCategoryName === "Earthing" ? (
          <span style={{ textTransform: "none" }}>Item (mm x mm)</span>
        ) : (
          "Item"
        ),
      dataIndex: "siteLocations",
      fixed: "left",
      width: 190,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.materialName}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "siteLocations",
      fixed: "right",
      width: 120,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <></>;
        } else if (record.siteName === "City Total") {
          return <></>;
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  // marginRight: "20px",
                  marginLeft: "5px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue">
                    {site.quantity}
                  </div>
                ))}
              </div>
            </>
          );
        }
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Preferred Unit of measurement means Your company buys material
              generally in this unit of measurement
            </span>
          }
        >
          Preferred UoM.
        </Tooltip>
      ),
      width: 120,
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        const defaultOption = pincodeList.find(
          (option) => option.unit_of_measurement === "MT",
        );
        const defaultValue = defaultOption ? defaultOption.id : 1;
        if (
          record.siteName === "City Total" ||
          record.siteName === "Site Sub-Total"
        ) {
          return "";
        }
        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => (
                <div
                  key={index}
                  className="lblvalue"
                  style={{ marginLeft: "5px" }}
                >
                  {/* {site.uom} */}
                  {site?.uom_name === "Cubic Meter"
                    ? "Cu. Mtr."
                    : site?.uom_name}
                </div>
              ))}
            </div>
          </>
        );
      },
    },
    !selectedCategoryName === "Earthing" && {
      title: "Qty. In Kg",
      dataIndex: "siteLocations",
      width: 100,
      // className: 'column-right',
      align: "right",
      render: (siteLocations, record) => {
        console.log("record001 ", record);

        if (record.siteName === "Site Sub-Total") {
          // return (
          //   <>
          //     <div
          //       className="subtotal"
          //       style={{
          //         display: "flex",
          //         flexDirection: "column",
          //         gap: "10px",
          //         float: "inline-end",
          //         // marginRight: "5px",
          //         //marginLeft: "5px"
          //       }}
          //     >
          //       {siteLocations.map((site, index) => (
          //         <span key={index} className="">
          //           {site.quantityForKG.toLocaleString()}
          //         </span>
          //       ))}
          //     </div>
          //   </>
          // );
        } else if (record.siteName === "City Total") {
          // return (
          //   <>
          //     <div
          //       className="citytotal"
          //       style={{
          //         display: "flex",
          //         flexDirection: "column",
          //         gap: "10px",
          //         float: "inline-end",
          //         // marginRight: "20px",
          //         //marginLeft: "5px"
          //       }}
          //     >
          //       {siteLocations.map((site, index) => (
          //         <span key={index} className="">
          //           {site.quantityForKG.toLocaleString()}
          //         </span>
          //       ))}
          //     </div>
          //   </>
          // );
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  //marginLeft: "5px"
                  marginRight: "5px",
                }}
              >
                {siteLocations.map((site, index) => {
                  console.log("site101 ", site);
                  return (
                    <div key={index} className="">
                      {site.subCategory === "RMC"
                        ? "-"
                        : site.quantityForKG.toLocaleString()}
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
      },
    },
    selectedCategoryName === "Earthing" && {
          title: "Est. Unit Rate",
          width: 140,
          align: "right",
          render: (_, record) => {
            if (
              record.siteName1 === "Site Sub Total" ||
              record.siteName1 === "City Total" ||
              record.siteName1 === "Total"
            ) {
              return null;
            }
    
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "flex-end",
                }}
              >
                {record.siteLocations.map((site, idx) => {
                  if (!site.materialName) return null;
    
                  const isEarthing = site.subCategory
                    ?.toLowerCase()
                    .includes("earthing");
    
                  if (isEarthing) {
                    const parsed = parseEarthingStrip(site.materialName);
                    if (parsed) {
                      const kgPerMeter = getKgPerMeter(
                        parsed.width,
                        parsed.thickness,
                        parsed.material
                      );
                      const ratePerKg =
                        site.estimated_price || site.estimatedPrice || 0;
                      const ratePerMeter = kgPerMeter * ratePerKg;
    
                      const supplierProfitPercent = 10;
                      const res = ratePerMeter * (1 + supplierProfitPercent / 100);
    
                      return (
                        <div
                          key={idx}
                          style={{ fontWeight: 500, color: "#d4380d" }}
                        >
                          ₹{" "}
                          {res?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}{" "}
                          / m
                        </div>
                      );
                    }
                  }
    
                  // For non-earthing items (Sand, Cement, etc.)
                  return (
                    <div key={idx}>
                      ₹ {site.estimated_price}{" "}
                      {site.uom_name === "MT" ? "/MT" : "/Kg"}
                    </div>
                  );
                })}
              </div>
            );
          },
        },
    selectedCategoryName !== "Earthing" && {
      title: "Est. Amount",
      dataIndex: "amount",
      key: "amount",
      width: 150,
      align: "right",

      render: (text, record) => {
        if (record.siteName === "Site Sub-Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="subtotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  // marginRight: "20px",
                  //marginLeft: "5px"
                }}
              >
                {record.siteLocations.map((site, index) => {
                  console.log("fdsite698 ", site, "record", record);
                  return (
                    <div key={index} className="">
                      ₹{" "}
                      {site.amount
                        ? site.amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else if (record.siteName === "City Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="citytotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  console.log("site698 ", site, "record", record);
                  return (
                    <div key={index} className="">
                      ₹ {site.amount ? site.amount.toLocaleString() : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "flex-end",
                  marginRight: "5px",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  console.log("site698 ", site, "record", record);
                  return (
                    <div key={index} className="lblvalue">
                      ₹ {site.amount ? site.amount.toLocaleString() : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        }
      },
    },
    selectedCategoryName === "Earthing" && {
          title: "Est. Amount",
          width: 170,
          align: "right",
          render: (_, record) => (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                alignItems: "flex-end",
              }}
            >
              {record.siteLocations.map((site, idx) => {
                console.log("site in amount column", site);
                // Handle subtotal / total rows
                if (!site.materialName) {
                  if (record.siteName1 === "Site Sub Total") {
                    return (
                      <div key={`subtotal-site-${record.key}`} className="subtotal">
                        ₹ {site.totalAmountByKG?.toLocaleString("en-IN") || 0}
                      </div>
                    );
                  }
                  if (record.siteName1 === "City Total") {
                    return (
                      <div key={`citytotal-${record.key}`} className="citytotal">
                        ₹ {site.cityTotalAmountForKG?.toLocaleString("en-IN") || 0}
                      </div>
                    );
                  }
                  if (record.siteName1 === "Total") {
                    console.log(
                      "site.totalCityOverallSite",
                      site.totalCityOverallSite
                    );
                    return (
                      <div
                        key="grandtotal"
                        className="totalCityOverallSitee5"
                        style={{ fontWeight: "bold" }}
                      >
                        ₹ {site.totalCityOverallSite?.toLocaleString("en-IN") || 0}
                      </div>
                    );
                  }
                  return <div key={`empty-${idx}`} />;
                }
    
                let amount = 0;
    
                // -------------------------------------------------------
                // 🟩 EARTHING ITEMS CALCULATION (corrected!)
                // -------------------------------------------------------
                if (site.subCategory?.toLowerCase().includes("earthing")) {
                  const profitPercent = 10;
                  console.log("site.materialName", site);
                  const parsed = parseEarthingStrip(site.materialName);
                  if (parsed) {
                    const kgPerMeter = getKgPerMeter(
                      parsed.width,
                      parsed.thickness,
                      parsed.material
                    );
    
                    const ratePerKg = site.estimatedPrice || 0;
    
                    // Step 1: base rate per meter
                    const ratePerMeter = kgPerMeter * ratePerKg;
    
                    // Step 2: include supplier profit
                    const finalRatePerMeter =
                      ratePerMeter * (1 + profitPercent / 100);
    
                    // Step 3: amount = meter qty × final rate
                    amount =
                      (site.quantity || 0) *
                      finalRatePerMeter.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      });
                    console.log("amdddount", amount);
                  }
                } else {
                  let totalKg = 0;
    
                  if (site.material_type_uom_name === "MT") {
                    totalKg = (site.quantity || 0) * 1000;
                  } else if (site.material_type_uom_name === "Bag") {
                    totalKg = (site.quantity || 0) * 50;
                  } else {
                    totalKg = site.quantity || 0;
                  }
    
                  amount = totalKg * (site.estimated_price || 0);
                }
                return (
                  <div key={`amount-${record.key}-${idx}`}>
                    ₹ {amount.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
                  </div>
                );
              })}
            </div>
          ),
        },
    {
      title: "Remarks",
      dataIndex: "siteLocations",
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.remark}
              </div>
            ))}
          </div>
        </>
      ),
    },
  ].filter(Boolean);

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  const theadPR = <Table columns={columns} />;

  const colors = ["#094E8F"];
  return (
    <>
      <Spin spinning={apiLoading}>
        <section className="grid-sec mt-5">
          <div className="PR-body tbl-collapse">
            {
              <>
                <Collapse defaultActiveKey={["1"]} className="scroll5">
                  <Panel header={theadPR} key="1">
                    <Table
                      columns={columns}
                      dataSource={tableData}
                      pagination={false}
                      scroll={{ x: "auto" }}
                    />
                  </Panel>
                </Collapse>
              </>
            }
          </div>
        </section>
      </Spin>
    </>
  );
};

NewCitywiseAssignPurchaseDetails.propTypes = {
  PRid: PropTypes.number,
};

export default NewCitywiseAssignPurchaseDetails;
